import React from 'react';
import { X, ExternalLink } from 'lucide-react';

function getTwitchEmbedUrl(twitchUrl) {
  if (!twitchUrl) return null;
  // Twitch VOD url: https://www.twitch.tv/videos/123456789
  const m = twitchUrl.match(/videos\/(\d+)/);
  if (!m) return null;
  const parent = window.location.hostname;
  return `https://player.twitch.tv/?video=v${m[1]}&parent=${parent}&autoplay=true`;
}

export default function VideoModal({ video, onClose }) {
  if (!video) return null;

  const twitchEmbed = video.twitchUrl ? getTwitchEmbedUrl(video.twitchUrl) : null;
  const clipEmbed = video.clipId
    ? `https://clips.twitch.tv/embed?clip=${encodeURIComponent(video.clipId)}&parent=${window.location.hostname}&autoplay=true`
    : null;
  const youtubeEmbed = video.youtubeId
    ? `https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&rel=0`
    : null;
  const src = clipEmbed || twitchEmbed || youtubeEmbed;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3 gap-4">
          <h3 className="text-white font-semibold pr-6 truncate flex-1">{video.title}</h3>
          <div className="flex items-center gap-2">
            {video.twitchUrl && (
              <a
                href={video.twitchUrl}
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-md bg-white/10 hover:bg-white/20 text-white"
                title="Open op Twitch"
              >
                <ExternalLink className="w-5 h-5" />
              </a>
            )}
            <button
              onClick={onClose}
              className="p-2 rounded-md bg-white/10 hover:bg-white/20 text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="relative aspect-video rounded-xl overflow-hidden border border-white/10 shadow-2xl shadow-violet-900/40 bg-black">
          {src ? (
            <iframe
              className="w-full h-full"
              src={src}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-zinc-400">
              Geen video beschikbaar
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
